module.exports = __webpack_public_path__ + "static/img/hscode_active.071ef1a8.svg";